import type { ReactNode } from "react"
import { useEffect } from "react"

import { useSession } from "@/lib/session"
import { createPresenceSocket } from "@/lib/sockets/presence"
import { usePresenceState } from "@/lib/states/presence-state"

export function PresenceProvider({ children }: { children: ReactNode }) {
	const { session } = useSession()
	const setOnline = usePresenceState((s) => s.setOnline)

	const workspaceId = session?.workspaceId
	const userId = session?.userId

	useEffect(() => {
		if (!workspaceId || !userId) return

		const socket = createPresenceSocket({
			workspaceId,
			userId,
			onState: ({ online }) => setOnline(online),
		})

		return () => {
			socket.close()
			setOnline([])
		}
	}, [workspaceId, userId, setOnline])

	return <>{children}</>
}
